
import React, { Component } from 'react'
import _iscroll from 'iscroll'
import IScroll from "react-iscroll"

import Nav from '../../Components/Nav'
import Link from '../../Components/HeaderLink'
import Dropdown from '../../Components/Dropdown'

import './header.css'

class Header extends Component {
	constructor(){
		super()
		this.onClick = this.onClick.bind(this)
		this.onChange = this.onChange.bind(this)
		this.searchSubmit = this.searchSubmit.bind(this)
		this.toogleSearchForm = this.toogleSearchForm.bind(this)
		this.toogleMenu = this.toogleMenu.bind(this)
		this.state = {
			isActive: false,
			searchIsOpen: false,
			menuIsOpen: false,
			searchValue: ''
		}
	}

	componentWillMount(){
		const {bottomMenu} = this.props
		let drops=[]; 
		bottomMenu.forEach((el,id)=>{
			if(el.children !== undefined ){
				drops[id] = {"id": el.id, "isActive": false}
			}
		})

		this.setState({
			drops
		})
	}


	toogleMenu(evt){
	    const body = document.getElementsByTagName('body');
	    if(this.state.menuIsOpen === false){
	      body[0].style.overflow = 'hidden';
	      this.setState({
	        menuIsOpen: true
	      })
	      setTimeout(()=>{
	        this.setState({
	          anim: true
	        })
	        this.refs.iScroll.refresh()
	      },100)      
	    }else{
	      this.setState({
	        anim: false
	      })
	      setTimeout(()=>{
	        this.setState({
	          menuIsOpen: false
	        })
	        body[0].style.overflow = '';
	      },400)
	    }
	}

	toogleSearchForm(){
		this.refs.search_field.focus()
		this.setState({
			searchIsOpen: this.state.searchIsOpen ? false : true
		})
	}

	onClick(evt){
		const {drops} = this.state
		this.setState({
			drops:  [...drops.map((el)=>( el.id === Number(evt.currentTarget.getAttribute('data-id')) ? {"id": el.id, "isActive": el.isActive === true ? false : true } :  {"id": el.id, "isActive": false} ))] 
		}) 
	}

	onChange(evt){
		const searchValue = evt.currentTarget.value

		this.setState({
			searchValue
		})
	}

	searchSubmit(evt){
		evt.preventDefault()
		const {searchValue} = this.state
		const {search_url} = this.props.search		
		if(searchValue.length>0){
			window.location = search_url+'?s='+searchValue;
		}
	}

	render(){
		const {searchIsOpen,menuIsOpen} = this.state
		const { languages, topMenu, privateArea, bottomMenu, logoinfo, search} = this.props

		const lang = languages && languages.languages !== undefined ? languages.languages.find((link,id)=>( id === 0 )) : '' 
		const options = {
	        mouseWheel: true,
	        scrollbars: false,
	        disablePointer: true,
	        disableTouch: false,
	        disableMouse: false,
	        scrollX: false, 
	        scrollY: true,
	        click: true,
	        tap: true
		}
		return(
			<header>
				<div className="header header--top">
					<div className={searchIsOpen ? "search__form js-active" :"search__form"} >
						<form action="" onSubmit={this.searchSubmit}>
							<button>
								<i className="fa fa-search" ></i>
							</button>
							<input type="text" ref="search_field" onChange={this.onChange} placeholder={search.placeholder} />
							<i className="fa fa-close" onClick={this.toogleSearchForm}></i>
						</form>
					</div>
					<div className="header__row">
						<div className="col">
							{languages && languages.languages !== undefined && languages.languages.length>1 ? 
								<div className="dropdown">
									<div>{lang.caption} <i className="fa fa-chevron-down"></i></div>
									<div className="drop">
										<div>
										{
											languages.languages.map((link)=>(
												<Link url={link.url} text={link.caption} target={link.target} key={link.id} className="" isActive={link.isActive} />
											))
										}
										</div>
									</div>
								</div>
							: '' }
						</div>
						<div className="col">
							<Nav links={topMenu} />
						</div>
						<div className="col">
							<div className="col search" onClick={this.toogleSearchForm}>
								<i className="fa fa-search"></i>
								<label>{search.placeholder}</label>
							</div>
							{privateArea.links.length >= 1 ?
								<div className="col dropdown dropdown--private">	
									<i className="fa fa-user"></i>
									<label>{privateArea.defaults.title}</label>
									<div className="drop">
										<div>
										{
											privateArea && privateArea.links ? privateArea.links.map((link)=>(
												<Link url={link.url} text={link.caption} target={link.target} key={link.id} className="" isActive={link.isActive} />
											)): ''
										}
										</div>
									</div>
								</div>
							: ''}
						</div>
					</div> 
				</div>
				<div className="header header--bottom">
					<div className="rows">
						<div className="col">
							<a href={logoinfo.url} className="a_logo"> 
								<img src={logoinfo.imgUrl} className="logo" alt="Master Vantagem" />
							</a>
						</div>
						<div className="col">
							<Nav links={bottomMenu} isActive={this.state.drops} dropdownOnClick={this.onClick} />
						</div>
						<div className="col">
							<div className={!menuIsOpen ? "btn__resp_menu" : "btn__resp_menu js-active"} onClick={this.toogleMenu}>
					          <div></div><div></div><div></div>
					        </div>
						</div>
					</div>
					{
						bottomMenu && bottomMenu ? bottomMenu.map((link,i)=>(
							link && link.children ? 
								<Dropdown children={link.children} isActive={this.state.drops[i].isActive} id={link.id} key={link.id} />
							: ''
						)): ''
					}
			
				</div>
				<div className={!menuIsOpen ? "resp__menu" : 'resp__menu js-active'} >
					<div className="resp__container">
						<div className="search__form" >
							<form action="" onSubmit={this.searchSubmit}>
								<button>
									<i className="fa fa-search" ></i>
								</button>
								<input type="text" ref="search_field" onChange={this.onChange} placeholder={search.placeholder} />
							</form>
						</div>
						<IScroll iScroll={_iscroll} options={options} ref="iScroll">
							<div>
								<div className="row">
									<div className="col">
										<Nav links={[topMenu[0]]} />
										<Nav links={bottomMenu} isActive={this.state.drops} withChildren={true} />
										<Nav links={topMenu.filter((el,id)=>( id !== 0 ))} />
									</div>
									<div className="col">
										{
											privateArea && privateArea.links.length >= 1 ? 
												<div className="label">
													<i className="fa fa-user"></i>
													<label>{privateArea.defaults.title}</label>
												</div>
											: ''
										}
											
										{
											privateArea && privateArea.links ? privateArea.links.map((link)=>(
												<Link url={link.url} text={link.caption} target={link.target} key={link.id} className="button" isActive={link.isActive} />
											)): ''
										}
										{
											languages && languages.languages !== undefined  && languages.languages.length>1 ? languages.languages.map((link)=>(
												<Link url={link.url} text={link.caption} target={link.target} key={link.id} className="button" isActive={link.isActive} />
											)): ''
										}
									</div>
								</div>
							</div>	
						</IScroll>
					</div>
				</div>
			</header>
		)
	}
}

export default Header


// WEBPACK FOOTER //
// ./src/Containers/Header/index.js